import { isTabletUp } from '../Utility/Breakpoint'
import { getElement, getElements } from '../Utility/Dom'

class NavBreadcrumb {
  private readonly button: HTMLElement | null
  private readonly links: NodeListOf<HTMLElement | null>

  constructor() {
    this.button = getElement('nav-breadcrumb-button')
    this.links = getElements('nav-breadcrumb-link')
  }

  init(): void {
    this.addEvents()
    this.toggleButtonAndLinkAttributes()
  }

  private addEvents(): void {
    this.button?.addEventListener('click', (): void => this.hideButtonShowLinks())

    window.addEventListener('resize', (): void => this.toggleButtonAndLinkAttributes())
  }

  private hideButtonShowLinks(): void {
    this.button?.setAttribute('aria-hidden', 'true')
    this.button?.setAttribute('aria-expanded', 'true')

    this.links.forEach((link): void => link.setAttribute('aria-hidden', 'false'))
  }

  private showButtonHideLinks(): void {
    this.button?.setAttribute('aria-hidden', 'false')
    this.button?.setAttribute('aria-expanded', 'false')

    this.links.forEach((link): void => link.setAttribute('aria-hidden', 'true'))
  }

  private toggleButtonAndLinkAttributes(): void {
    if (isTabletUp() === true) {
      this.hideButtonShowLinks()
    } else {
      this.showButtonHideLinks()
    }
  }
}

const navBreadcrumb = new NavBreadcrumb()
navBreadcrumb.init()
